import React, { useState, useEffect } from 'react';
import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
  Navigate,
  useLocation,
} from 'react-router-dom';
import Dashboard from './Pages/Dashboard/Dashboard';
import Conversations from './Pages/Message/Conversations';
import Documents from './Pages/Documents/Documents';
import NotFound from './Pages/NotFound';
import Login from './Pages/Login/Login';
import ForgotPassword from './Pages/Login/ForgotPassword';
import ResetPassword from './Pages/Login/ResetPassword';
import ChangePassword from './Pages/Login/ChangePassword';
import Roster from './Pages/Roster/Roster';
import RosterDetail from './Pages/Roster/RosterDetail';
import Irs from './Pages/Irs/Irs';
import IrsDetail from './Pages/Irs/IrsDetail';
import Training from './Pages/Training/Training';
import TrainingCreate from './Pages/Training/TrainingCreate';
import TrainingEdit from './Pages/Training/TrainingEdit';
import ReleaseNotes from './Pages/Releases/ReleaseNotes';
import { Grid } from '@mui/material';
import Footer from './Footer';
import TrainingDetail from './Pages/Training/TrainingDetail';
import Donations from './Pages/Donations/public/Donations';
import UserList from './Pages/Users/UserList';
import { applications } from './utils/variables';
import LCChapterList from './Pages/Chapters/LocalChapter/LCChapterList';
import SPDChapterList from './Pages/Chapters/SPDChapter/SPDChapterList';
import BnBList from './Pages/BedAndBreakfast/BnBList';
import BnBCreate from './Pages/BedAndBreakfast/BnBCreate';
import DonationsList from './Pages/Donations/internal/DonationsList';
import ReciprocityDetail from './Pages/Chapters/Reciprocities/ReciprocityDetail';
import ReciprocityList from './Pages/Chapters/Reciprocities/ReciprocityList';
import TLCList from './Pages/TLC/TLCList';
import ELFLanding from './Pages/Projects/ELF';
import StarLandingPage from './Pages/Projects/Star';
import PCELandingPage from './Pages/Projects/PCE';
import PSALandingPage from './Pages/Projects/PSA';
import IPSLandingPage from './Pages/Projects/IPS';
import FoundationLandingPage from './Pages/Projects/Foundation';
import {
  MarketplaceList,
  MarketplaceDetail,
  MarketplaceCreate,
  MarketplaceEdit,
} from './Pages/Marketplace';
import NewsfeedList from './Pages/Newsfeed/NewsfeedList';
import NewsfeedDetail from './Pages/Newsfeed/NewsfeedDetail';
import NewsfeedCreate from './Pages/Newsfeed/NewsfeedCreate';
import NewsFeedView from './Pages/Newsfeed/NewsFeedView';
import DonationDetail from './Pages/Donations/internal/DonationDetail';
import UserDetail from './Pages/Users/UserDetail';
import IntroductionList from './Pages/Users/IntroOfWoman/IntroductionList';
import IntroductionDetail from './Pages/Users/IntroOfWoman/IntroductionDetail';
import IntroductionForm from './Pages/Users/IntroOfWoman/IntroductionForm';
import SideDrawer from './Drawer';
import { styled } from '@mui/material/styles';
import SPDChapterDetail from './Pages/Chapters/SPDChapter/SPDChapterDetail';
import LCDetail from './Pages/Chapters/LocalChapter/LCDetail';
import EventDetailPage from './Pages/Chapters/LocalChapter/EventDetailPage';
import ElectionOfOfficersWizard from './Pages/Chapters/LocalChapter/ElectionOfOfficersWizard';
import LCCommitteesPage from './Pages/Chapters/LocalChapter/LCCommitteesPage';
import LCSocialPage from './Pages/Chapters/LocalChapter/LCSocialPage';
import LCEventsPage from './Pages/Chapters/LocalChapter/LCEventsPage';
import LCBylawsPage from './Pages/Chapters/LocalChapter/LCBylawsPage';
import Report from './Pages/Reports/Report';
import { getMe } from './endpoints/login';
import { jwtDecode } from 'jwt-decode';
import { useApiGet } from './utils/httpClient';
import TLCDetail from './Pages/TLC/TLCDetail';
import BnBDetail from './Pages/BedAndBreakfast/BnBDetail';
import Cottey from './Pages/Projects/Cottey';
import IntlDetail from './Pages/Chapters/International/InternationalDetail';
import FeedbackCreate from './Pages/Feedback/ContactUs';
import SeekingTransferList from './Pages/Users/SeekingTransfer/SeekingTransferList';
import SeekingTransferDetail from './Pages/Users/SeekingTransfer/SeekingTransferDetail';
import SeekingTransferCreate from './Pages/Users/SeekingTransfer/SeekingTransferCreate';
import ConversationDetail from './Pages/Message/ConversationDetail';
import DocumentLibrary from './Pages/Library/DocumentLibrary';
import DocumentManager from './Pages/Library/DocumentManager';
import DocumentView from './Pages/Library/DocumentView';
import DocumentViewLatest from './Pages/Library/DocumentViewLatest';
import DocumentVersionDetail from './Pages/Library/DocumentVersionDetail';
import DocumentCreate from './Pages/Library/DocumentCreate';
import DocumentEdit from './Pages/Library/DocumentEdit';
import DocumentBundle from './Pages/Library/DocumentBundle';
import GroupPermissions from './Pages/Library/GroupPermissions';
import LeadershipDevelopment from './Pages/LDC/LeadershipDevelopment';
import Map from './Pages/Maps/Map';
import { config } from './utils/config';
import AnnualReportsDashboard from './Pages/AnnualReports/AnnualReportsDashboard';
import Prework from './Pages/AnnualReports/Prework';
import RosterDuesLanding from './Pages/AnnualReports/RosterDues/RosterDuesLanding';
import RosterDuesList from './Pages/AnnualReports/RosterDues/RosterDuesList';
import RosterDuesMemberList from './Pages/AnnualReports/RosterDues/RosterDuesMemberList';
import RosterDuesSummary from './Pages/AnnualReports/RosterDues/RosterDuesSummary';
import RosterDuesChapterList from './Pages/AnnualReports/RosterDues/RosterDuesChapterList';
import RosterDuesSPDSummary from './Pages/AnnualReports/RosterDues/RosterDuesSPDSummary';
import IRSFormsLanding from './Pages/AnnualReports/IRSForms/IRSFormsLanding';
import IRSFormsList from './Pages/AnnualReports/IRSForms/IRSFormsList';
import IRSFormsDetail from './Pages/AnnualReports/IRSForms/IRSFormsDetail';
import ARResources from './Pages/AnnualReports/Resources';
import ARTraining from './Pages/AnnualReports/Training';
import SPDPreworkForm from './Pages/AnnualReports/Prework/SPDPreworkForm';
import SPDPreworkList from './Pages/AnnualReports/Prework/SPDPreworkList';
import PEOReportsList from './Pages/PEOReports/PEOReportsList';
import PEOReportDetail from './Pages/PEOReports/PEOReportDetail';
import Permissions from './Pages/Administration/Permissions';
import ExecutiveOffice from './Pages/Administration/ExecutiveOffice';
import ScheduledTasks from './Pages/Administration/ScheduledTasks';
import EmailCampaignsList from './Pages/Administration/EmailCampaignsList';
import EmailCampaignDetail from './Pages/Administration/EmailCampaignDetail';
import NoticeManagementList from './Pages/Administration/NoticeManagementList';
import NoticeManagementCreate from './Pages/Administration/NoticeManagementCreate';
import NoticeManagementEdit from './Pages/Administration/NoticeManagementEdit';
import LoansTestList from './Pages/Administration/LoansTestList';
import LoansTestCreate from './Pages/Administration/LoansTestCreate';
import LoansTestDetail from './Pages/Administration/LoansTestDetail';
import ChapterSuppliesLanding from './Pages/ChapterSuppliesManagement/ChapterSuppliesLanding';
import ItemList from './Pages/ChapterSuppliesManagement/Items/ItemList';
import ItemDetail from './Pages/ChapterSuppliesManagement/Items/ItemDetail';
import ItemCreate from './Pages/ChapterSuppliesManagement/Items/ItemCreate';
import VendorList from './Pages/ChapterSuppliesManagement/Vendors/VendorList';
import VendorCreate from './Pages/ChapterSuppliesManagement/Vendors/VendorCreate';
import VendorDetail from './Pages/ChapterSuppliesManagement/Vendors/VendorDetail';
import OnlineItemList from './Pages/ChapterSuppliesManagement/OnlineItems/OnlineItemList';
import OnlineItemCreate from './Pages/ChapterSuppliesManagement/OnlineItems/OnlineItemCreate';
import OnlineItemDetail from './Pages/ChapterSuppliesManagement/OnlineItems/OnlineItemDetail';
import InventoryPage from './Pages/ChapterSuppliesManagement/Inventory/InventoryPage';
import PlaceholderPage from './Pages/ChapterSuppliesManagement/PlaceholderPage';

const PrivateRoutes = () => {
  const location = useLocation();
  // Check auth in render to ensure it's reactive
  const auth = localStorage.getItem('user_id');

  if (!auth) {
    // Don't capture login page as returnUrl (would cause infinite loop)
    if (location.pathname === '/login') {
      return <Navigate to="/login" replace />;
    }

    // Save the intended destination before redirecting to login
    const returnUrl = location.pathname + location.search;
    return (
      <Navigate
        to={`/login?returnUrl=${encodeURIComponent(returnUrl)}`}
        replace
      />
    );
  }

  return <Outlet />;
};

const MessageAdmin = () => {
  let apps = localStorage.getItem('apps');
  if (!apps) return false;
  let messageUsers = [applications.MessageAdmin, applications.MessageApprover];
  return messageUsers.some((app) => apps.includes(app)) ? (
    <Outlet />
  ) : (
    <Navigate to="/" />
  );
};

const IsNewsfeedAdmin = () => {
  let apps = localStorage.getItem('apps');
  if (!apps) return false;
  let allowed = apps.includes(applications.NewsfeedAdmin);
  return allowed ? <Outlet /> : <Navigate to="/" />;
};

const IsDocumentAdmin = () => {
  let apps = localStorage.getItem('apps');
  if (!apps) return false;
  let allowed = apps.includes(applications.DocumentAdmin);
  return allowed ? <Outlet /> : <Navigate to="/" />;
};

const IsAnnualReportsUser = () => {
  let pages = localStorage.getItem('pages');
  if (!pages) return <Navigate to="/" />;
  let allowed = pages.includes('annual-reports');
  return allowed ? <Outlet /> : <Navigate to="/" />;
};

const CanViewPermissions = () => {
  let pages = localStorage.getItem('pages');
  if (!pages) return <Navigate to="/" />;
  let allowed = pages.includes('permissions');
  return allowed ? <Outlet /> : <Navigate to="/" />;
};

const CanViewExecutiveOffice = () => {
  let pages = localStorage.getItem('pages');
  if (!pages) return <Navigate to="/" />;
  let allowed = pages.includes('exec-office');
  return allowed ? <Outlet /> : <Navigate to="/" />;
};

const CanViewNoticeManagement = () => {
  let pages = localStorage.getItem('pages');
  if (!pages) return <Navigate to="/" />;
  let allowed = pages.includes('notice-management');
  return allowed ? <Outlet /> : <Navigate to="/" />;
};

const CanViewChapterSuppliesManagement = () => {
  let pages = localStorage.getItem('pages');
  if (!pages) return <Navigate to="/" />;
  let allowed = pages.includes('supplies-management');
  return allowed ? <Outlet /> : <Navigate to="/" />;
};

const CanViewLoansManage = () => {
  let pages = localStorage.getItem('pages');
  if (!pages) return <Navigate to="/" />;
  let allowed = pages.includes('loan-manage');
  return allowed ? <Outlet /> : <Navigate to="/" />;
};

const CanViewSeekingTransfer = () => {
  const location = useLocation();
  const pathname = location.pathname.replace(/\/$/, '') || '/';
  const isListRoute = pathname === '/seeking-transfer';

  if (isListRoute) {
    const pages = localStorage.getItem('pages');
    if (!pages) return <Navigate to="/" />;
    if (!pages.includes('seeking-transfer')) return <Navigate to="/" />;
  }

  return <Outlet />;
};

const drawerWidth = 300;

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: 0,
    variants: [
      {
        props: ({ open }) => open,
        style: {
          transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
          }),
          marginLeft: `${drawerWidth}px`,
        },
      },
    ],
  })
);

const isMobile = window.innerWidth <= 768;

// Root layout: drawer, main content area (Outlet), and footer. Used by data router.
const RootLayout = () => {
  const location = useLocation();
  const [open, setOpen] = useState(true);
  const [enableGetMe, setEnableGetMe] = useState(false);

  useEffect(() => {
    const hasUserId = !!localStorage.getItem('user_id');
    const hasRefreshToken = !!localStorage.getItem('refresh');
    if (hasUserId && hasRefreshToken) {
      const timer = setTimeout(() => setEnableGetMe(true), 100);
      return () => clearTimeout(timer);
    }
    setEnableGetMe(false);
  }, [location.pathname]);

  const { data } = useApiGet(['refresh'], getMe, {
    enabled: enableGetMe,
    retry: 0,
    refetchInterval: 60 * 60000,
  });

  const loggedIn = !!localStorage.getItem('user_id');
  const isPublicRoute =
    location.pathname === '/login' ||
    location.pathname === '/forgot-password' ||
    location.pathname.startsWith('/reset-password/') ||
    location.pathname === '/change-password';
  const shouldShowDrawer = loggedIn && !isPublicRoute;

  const handleUpdateDrawer = () => setOpen(!open);

  useEffect(() => {
    if (data) {
      try {
        localStorage.setItem('token', data.access_token);
        const decoded = jwtDecode(data.access_token);
        if (decoded.sub) localStorage.setItem('user_id', decoded.sub);
        if (decoded.first_name)
          localStorage.setItem('first_name', decoded.first_name);
        if (decoded.last_name)
          localStorage.setItem('last_name', decoded.last_name);
        if (decoded.applications?.length)
          localStorage.setItem('apps', decoded.applications.join(','));
        if (decoded.pages?.length)
          localStorage.setItem('pages', decoded.pages.join(','));
        if (decoded.role) localStorage.setItem('role', decoded.role);
      } catch (error) {
        console.error(
          'Error decoding token or writing to localStorage:',
          error
        );
        localStorage.clear();
        window.location.href = '/login';
      }
    }
  }, [data]);

  return (
    <Grid sx={{ position: 'relative', minHeight: '100vh' }}>
      {shouldShowDrawer && (
        <SideDrawer
          open={open}
          isMobile={isMobile}
          handleUpdateDrawer={handleUpdateDrawer}
          drawerWidth={drawerWidth}
        />
      )}
      {isMobile ? (
        <Grid item xs={12} paddingBottom={12}>
          <Outlet />
        </Grid>
      ) : (
        <Grid item xs={12} paddingBottom={11}>
          {shouldShowDrawer ? (
            <Main open={open}>
              <Outlet />
            </Main>
          ) : (
            <Outlet />
          )}
        </Grid>
      )}
      {loggedIn && (
        <Grid item xs={12}>
          <Footer />
        </Grid>
      )}
    </Grid>
  );
};

// Route config for data router. Order matters for matching.
function buildRoutesConfig() {
  const privateRoutesChildren = [
    { index: true, element: <Dashboard /> },
    { path: 'roster', element: <Roster /> },
    { path: 'roster/:id', element: <RosterDetail /> },
    { path: 'irs', element: <Irs /> },
    { path: 'reports', element: <Report /> },
    ...(config.NEW_REPORTS_ENABLED
      ? [
          { path: 'peo-reports', element: <PEOReportsList /> },
          { path: 'peo-reports/:id', element: <PEOReportDetail /> },
        ]
      : []),
    { path: 'irs/:id', element: <IrsDetail /> },
    { path: 'training', element: <Training /> },
    { path: 'training/create', element: <TrainingCreate /> },
    { path: 'training/:id/edit', element: <TrainingEdit /> },
    { path: 'training/:id', element: <TrainingDetail /> },
    { path: 'documents', element: <Documents /> },
    {
      element: <IsDocumentAdmin />,
      children: [
        { path: 'library/create', element: <DocumentCreate /> },
        { path: 'library/:id/versions', element: <DocumentVersionDetail /> },
        {
          path: 'library/:id/versions/:versionId',
          element: <DocumentVersionDetail />,
        },
        { path: 'library/:id/edit', element: <DocumentEdit /> },
        { path: 'library/manager', element: <DocumentManager /> },
        { path: 'library/group-permissions', element: <GroupPermissions /> },
      ],
    },
    { path: 'library/document/:id/latest', element: <DocumentViewLatest /> },
    { path: 'library/:id/view/:versionId', element: <DocumentView /> },
    { path: 'library/bundles/:bundleId', element: <DocumentBundle /> },
    { path: 'library', element: <DocumentLibrary /> },
    { path: 'release-notes', element: <ReleaseNotes /> },
    { path: 'local-chapters', element: <LCChapterList /> },
    {
      path: 'local-chapters/:id/election-of-officers',
      element: <ElectionOfOfficersWizard />,
    },
    {
      path: 'local-chapters/:id/events/:eventId',
      element: <EventDetailPage />,
    },
    {
      path: 'local-chapters/:id/committees',
      element: <LCCommitteesPage />,
    },
    {
      path: 'local-chapters/:id/social',
      element: <LCSocialPage />,
    },
    {
      path: 'local-chapters/:id/events',
      element: <LCEventsPage />,
    },
    {
      path: 'local-chapters/:id/bylaws',
      element: <LCBylawsPage />,
    },
    { path: 'local-chapters/:id', element: <LCDetail /> },
    { path: 'spd-chapters', element: <SPDChapterList /> },
    { path: 'spd-chapters/:id', element: <SPDChapterDetail /> },
    { path: 'international', element: <IntlDetail /> },
    { path: 'bnb', element: <BnBList /> },
    { path: 'bnb/create', element: <BnBCreate /> },
    { path: 'bnb/:id', element: <BnBDetail /> },
    { path: 'internal/donations', element: <DonationsList /> },
    { path: 'internal/donations/:id', element: <DonationDetail /> },
    { path: 'leadership-development', element: <LeadershipDevelopment /> },
    { path: 'tlc', element: <TLCList /> },
    { path: 'tlc/:id', element: <TLCDetail /> },
    { path: 'user', element: <UserList /> },
    { path: 'user/:id', element: <UserDetail /> },
    { path: 'introductions', element: <IntroductionList /> },
    { path: 'introductions/:id', element: <IntroductionDetail /> },
    { path: 'introductions/create', element: <IntroductionForm /> },
    { path: 'reciprocity', element: <ReciprocityList /> },
    { path: 'reciprocity/:id', element: <ReciprocityDetail /> },
    { path: 'projects/elf', element: <ELFLanding /> },
    { path: 'projects/star', element: <StarLandingPage /> },
    { path: 'projects/pce', element: <PCELandingPage /> },
    { path: 'projects/psa', element: <PSALandingPage /> },
    { path: 'projects/ips', element: <IPSLandingPage /> },
    {
      element: <IsNewsfeedAdmin />,
      children: [
        { path: 'newsfeed', element: <NewsfeedList /> },
        { path: 'newsfeed/:id', element: <NewsfeedDetail /> },
        { path: 'newsfeed/create', element: <NewsfeedCreate /> },
      ],
    },
    { path: 'newsfeed/view/:id', element: <NewsFeedView /> },
    {
      element: <CanViewSeekingTransfer />,
      children: [
        { path: 'seeking-transfer', element: <SeekingTransferList /> },
        { path: 'seeking-transfer/:id', element: <SeekingTransferDetail /> },
        {
          path: 'seeking-transfer/create/:userId',
          element: <SeekingTransferCreate />,
        },
      ],
    },
    { path: 'foundation', element: <FoundationLandingPage /> },
    { path: 'cottey', element: <Cottey /> },
    { path: 'marketplace', element: <MarketplaceList /> },
    { path: 'marketplace/:id', element: <MarketplaceDetail /> },
    { path: 'marketplace/create', element: <MarketplaceCreate /> },
    { path: 'marketplace/:id/edit', element: <MarketplaceEdit /> },
    {
      element: <CanViewChapterSuppliesManagement />,
      children: [
        {
          path: 'chapter-supplies-management',
          element: <ChapterSuppliesLanding />,
        },
        { path: 'chapter-supplies-management/items', element: <ItemList /> },
        {
          path: 'chapter-supplies-management/items/create',
          element: <ItemCreate />,
        },
        {
          path: 'chapter-supplies-management/items/:id',
          element: <ItemDetail />,
        },
        {
          path: 'chapter-supplies-management/vendors',
          element: <VendorList />,
        },
        {
          path: 'chapter-supplies-management/vendors/create',
          element: <VendorCreate />,
        },
        {
          path: 'chapter-supplies-management/vendors/:id',
          element: <VendorDetail />,
        },
        {
          path: 'chapter-supplies-management/purchase-orders',
          element: <PlaceholderPage title="Purchase Orders" />,
        },
        {
          path: 'chapter-supplies-management/inventory',
          element: <InventoryPage />,
        },
        {
          path: 'chapter-supplies-management/online-items',
          element: <OnlineItemList />,
        },
        {
          path: 'chapter-supplies-management/online-items/create',
          element: <OnlineItemCreate />,
        },
        {
          path: 'chapter-supplies-management/online-items/:id',
          element: <OnlineItemDetail />,
        },
      ],
    },
    { path: 'conversations', element: <Conversations /> },
    { path: 'conversations/:id', element: <ConversationDetail /> },
    { path: 'feedback/create', element: <FeedbackCreate /> },
    { path: 'map', element: <Map /> },
    {
      element: <IsAnnualReportsUser />,
      children: [
        { path: 'annual-reports', element: <AnnualReportsDashboard /> },
        { path: 'annual-reports/prework', element: <Prework /> },
        { path: 'annual-reports/prework/spd', element: <SPDPreworkList /> },
        { path: 'prework/spd/:id', element: <SPDPreworkForm /> },
        { path: 'annual-reports/prework/spd/:id', element: <SPDPreworkForm /> },
        {
          path: 'annual-reports/prework/spd-dues/:id',
          element: <SPDPreworkForm />,
        },
        { path: 'annual-reports/roster-dues', element: <RosterDuesLanding /> },
        {
          path: 'annual-reports/roster-dues/local-chapters',
          element: <RosterDuesList formType="local_chapter" />,
        },
        {
          path: 'annual-reports/roster-dues/spd',
          element: <RosterDuesList formType="spd" />,
        },
        {
          path: 'annual-reports/roster-dues/:id/members',
          element: <RosterDuesMemberList />,
        },
        {
          path: 'annual-reports/roster-dues/:id/chapters',
          element: <RosterDuesChapterList />,
        },
        {
          path: 'annual-reports/roster-dues/:id/summary',
          element: <RosterDuesSummary />,
        },
        {
          path: 'annual-reports/roster-dues/:id/spd-summary',
          element: <RosterDuesSPDSummary />,
        },
        { path: 'annual-reports/irs-forms', element: <IRSFormsLanding /> },
        {
          path: 'annual-reports/irs-forms/:year/local-chapters',
          element: <IRSFormsList formType="lc" />,
        },
        {
          path: 'annual-reports/irs-forms/:year/spd',
          element: <IRSFormsList formType="sc" />,
        },
        {
          path: 'annual-reports/irs-forms/:year/reciprocity',
          element: <IRSFormsList formType="rg" />,
        },
        {
          path: 'annual-reports/irs-forms/:year/local-chapters/:id',
          element: <IRSFormsDetail />,
        },
        {
          path: 'annual-reports/irs-forms/:year/spd/:id',
          element: <IRSFormsDetail />,
        },
        {
          path: 'annual-reports/irs-forms/:year/reciprocity/:id',
          element: <IRSFormsDetail />,
        },
        { path: 'annual-reports/resources', element: <ARResources /> },
        { path: 'annual-reports/training', element: <ARTraining /> },
      ],
    },
    {
      element: <CanViewPermissions />,
      children: [
        { path: 'administration/permissions', element: <Permissions /> },
        { path: 'administration/scheduled-tasks', element: <ScheduledTasks /> },
      ],
    },
    {
      element: <CanViewExecutiveOffice />,
      children: [
        {
          path: 'administration/executive-office',
          element: <ExecutiveOffice />,
        },
      ],
    },
    {
      element: <CanViewNoticeManagement />,
      children: [
        {
          path: 'administration/notice-management',
          element: <NoticeManagementList />,
        },
        {
          path: 'administration/notice-management/new',
          element: <NoticeManagementCreate />,
        },
        {
          path: 'administration/notice-management/:id',
          element: <NoticeManagementEdit />,
        },
      ],
    },
    {
      element: <CanViewLoansManage />,
      children: [
        { path: 'administration/loans-test', element: <LoansTestList /> },
        {
          path: 'administration/loans-test/create',
          element: <LoansTestCreate />,
        },
        { path: 'administration/loans-test/:id', element: <LoansTestDetail /> },
      ],
    },
    { element: <MessageAdmin />, children: [] },
  ];

  return [
    { path: 'login', element: <Login /> },
    { path: 'forgot-password', element: <ForgotPassword /> },
    { path: 'reset-password/:token', element: <ResetPassword /> },
    { path: 'change-password', element: <ChangePassword /> },
    { path: 'donations', element: <Donations /> },
    { path: 'administration/email-campaigns', element: <EmailCampaignsList /> },
    {
      path: 'administration/email-campaigns/new',
      element: <EmailCampaignsList />,
    },
    {
      path: 'administration/email-campaigns/:id',
      element: <EmailCampaignDetail />,
    },
    { element: <PrivateRoutes />, children: privateRoutesChildren },
    { path: '*', element: <NotFound /> },
  ];
}

const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    children: buildRoutesConfig(),
  },
]);

const Router = () => {
  return <RouterProvider router={router} />;
};

export default Router;
